export default __webpack_public_path__ + "static/media/bar_chart.6e59031a.svg";